import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify, {
    iconfont: 'md',
    theme: {
        primary: '#14b5b1',
        secondary: '#42aa72',
        secondary2: '#f3c460',
        price: '#f96b00',
        yellow: '#f4e4a9',
        accent: '#8c9eff',
        error: '#f04545',
    }
})
